export default __webpack_public_path__ + "static/media/disable.b791572e.svg";